import { COUNTRY } from '@qflow/constants'

export const isValidTimeZone = (tz: string | null): boolean => {
  try {
    if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
      return false
    }

    if (typeof tz !== 'string') {
      return false
    }

    // throws an error if timezone is not valid
    Intl.DateTimeFormat(undefined, { timeZone: tz })
    return true
  } catch (error) {
    return false
  }
}

export const usDateFormatter = (dateString: string): string => {
  if (!dateString || dateString === '') {
    return ''
  }
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })
}

export const getLocaleFromCountry = (country: string | null): string => {
  if (typeof country === 'string') {
    return country === COUNTRY.USA
      ? 'en-US'
      : country === COUNTRY.AUSTRALIA
        ? 'en-AU'
        : 'en-GB'
  }

  return 'en-GB'
}

export const getLocaleFromTimeZone = (tz: string | null): string => {
  if (typeof tz === 'string' && isValidTimeZone(tz)) {
    return tz.startsWith('America')
      ? 'en-US'
      : tz.startsWith('Australia')
        ? 'en-AU'
        : 'en-GB'
  }

  return 'en-GB'
}

export const getOffset = (timeZone: string, date: Date) => {
  if (!isValidTimeZone(timeZone)) {
    return 0
  }

  const timeZoneName = Intl.DateTimeFormat('ia', {
    timeZoneName: 'short',
    timeZone: timeZone || 'Europe/London'
  })
    ?.formatToParts(date)
    ?.find(i => i.type === 'timeZoneName')?.value
  let offset = timeZoneName?.slice(3)
  if (timeZoneName === 'BST') {
    offset = '+1'
  }

  if (!offset) return 0

  const matchData = offset.match(/([+-])(\d{1,2})(?::(\d{1,2}))?/)
  if (!matchData) throw `cannot parse timezone name: ${timeZoneName}`

  const [, sign, hour, minute] = matchData
  let result = parseInt(hour) * 60

  if (minute) result += parseInt(minute)
  if (sign === '+') result *= -1

  return result
}

export const compareDatesWithOffSets = (
  firstDate: string,
  timeZone: string,
  secondDate: string
) => {
  if (firstDate && timeZone && secondDate) {
    return (
      new Date(
        new Date(firstDate).getTime() +
          getOffset(timeZone, new Date(firstDate)) * 60000
      ) >
      new Date(
        new Date(secondDate).getTime() +
          new Date(secondDate).getTimezoneOffset() * 60000
      )
    )
  }
  return false
}
